import Vue from 'vue';
import { database } from "@/plugins/firebase";
import store from "@/store";
import _ from 'lodash';
import { logActivity } from '@/services/ActivityLogService';
const StandardOperatingHoursCollection = 'standardOperatingHours';
export const defaultOperatingHour = {
    id: '',
    data: {
        validFrom: '1970-01-01',
        days: [
            { number: 1, openFrom: 13, openTo: 20, pauses: [] },
            { number: 2, openFrom: 13, openTo: 20, pauses: [] },
            { number: 3, openFrom: 13, openTo: 20, pauses: [] },
            { number: 4, openFrom: 13, openTo: 20, pauses: [] },
            { number: 5, openFrom: 13, openTo: 20, pauses: [] },
            { number: 6, openFrom: 9, openTo: 21, pauses: [16] },
            { number: 0, openFrom: 9, openTo: 21, pauses: [16] },
        ],
    }
};
export const StandardOperatingHoursModule = {
    namespaced: true,
    state: [],
    mutations: {
        store(state, standardOperatingHour) {
            const x = state.find(x => x.id === standardOperatingHour.id);
            if (x) {
                if (_.isEqual(x, standardOperatingHour)) {
                    return;
                }
                state.splice(state.indexOf(x), 1, standardOperatingHour);
                store.dispatch('standardOperatingHours/storeCache');
                return;
            }
            state.push(standardOperatingHour);
            store.dispatch('standardOperatingHours/storeCache');
        },
        update(state, standardOperatingHours) {
            state.find((oldStandardOperatingHours, index) => {
                if (oldStandardOperatingHours.id === standardOperatingHours.id) {
                    Vue.set(state, index, standardOperatingHours);
                }
            });
        },
        destroy(state, standardOperatingHours) {
            state.splice(state.findIndex(item => standardOperatingHours.id === item.id), 1);
        },
        clear(state) {
            state.splice(0, state.length);
        },
    },
    actions: {
        async store(context, standardOperatingHours) {
            await database.collection(StandardOperatingHoursCollection).add(standardOperatingHours.data);
            // Log activity (fire-and-forget)
            logActivity('CREATE', 'operatingHours', standardOperatingHours.id || 'new', null, standardOperatingHours.data);
        },
        async update(context, standardOperatingHours) {
            let document = await database.collection(StandardOperatingHoursCollection).doc(standardOperatingHours.id);
            await document.update(standardOperatingHours.data);
            // Log activity (fire-and-forget)
            logActivity('UPDATE', 'operatingHours', standardOperatingHours.id, null, standardOperatingHours.data);
        },
        async destroy(context, standardOperatingHours) {
            // Log activity (fire-and-forget)
            logActivity('DELETE', 'operatingHours', standardOperatingHours.id, standardOperatingHours.data, null);
            await database.collection(StandardOperatingHoursCollection).doc(standardOperatingHours.id).delete();
        },
        async listen(context) {
            context.commit('clear');
            //await context.dispatch('loadCache');
            return database.collection(StandardOperatingHoursCollection).onSnapshot(snapshot => {
                for (let change of snapshot.docChanges()) {
                    switch (change.type) {
                        case 'added':
                            context.commit('store', { id: change.doc.id, data: change.doc.data() });
                            break;
                        case 'modified':
                            context.commit('update', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                        case 'removed':
                            context.commit('destroy', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                    }
                }
            });
        },
        async storeCache(context) {
            localStorage.removeItem(StandardOperatingHoursCollection);
            try {
                localStorage.setItem(StandardOperatingHoursCollection, JSON.stringify(context.state));
            }
            catch (e) { }
        },
        async loadCache(context) {
            const cache = localStorage.getItem(StandardOperatingHoursCollection);
            if (!cache) {
                return;
            }
            const standardOperatingHours = JSON.parse(cache);
            for (const standardOperatingHour of standardOperatingHours) {
                context.commit('store', { id: standardOperatingHour.id, data: standardOperatingHour.data });
            }
        },
    },
    getters: {
        all(state) {
            return state;
        },
        current(state) {
            return state.reduce((last, current) => {
                return current.data.validFrom > last.data.validFrom ? current : last;
            }, defaultOperatingHour);
        }
    }
};
